import styled from 'styled-components';
import { zIndex } from '@styles/zIndex.styles';
import { NAV_SIDEBAR_WIDTH } from '@components/navSidebar/NavSidebar.styles';
import { device } from '@styles/tools/breakpoints.styles';
import { Box, Button } from '@agilize/components-core';
import { ButtonProps } from '@agilize/components-core/dist/components/button/Button.types';
import { flex } from 'styled-system';
import { green } from '@material-ui/core/colors';

export const StyledHeader = styled.div`
  overflow: inherit;
  align-items: center;
  display: flex;
  position: fixed;
  width: 100%;
  left: 0;
  z-index: ${zIndex.header};
  background: ${props => props.theme.colors.grey100};
  padding-left: 0;
  box-shadow: 1px 0 4px ${props => props.theme.colors.grey400};

  ${device.desktopLarge} {
    padding-right: ${NAV_SIDEBAR_WIDTH}px;
  }

  ${device.desktop} {
    box-shadow: ${props => (props.active ? `1px 0 4px ${props => props.theme.colors.grey400}` : 'unset')};
    padding-left: ${NAV_SIDEBAR_WIDTH}px;
  }
`;

export const StyledCompanyHeader = styled.div`
  font-weight: 600;
  font-size: ${props => props.theme.fontSizes[3]};
  color: ${props => props.theme.colors.grey900};

  ${device.tablet} {
    margin-left: ${props => props.theme.global.gutterSpace * 3}px;
  }
  ${device.mobile} {
    display: none;
  }
`;

export const WhiteButton = styled.div`
  display: inline-flex;
  background: ${props => props.theme.colors.white};
  border-radius: 50%;
  width: 40px;
  height: 40px;
  transition: transform ease-in-out 0.2s, margin-left ease-in-out 0.2s;
  transform: ${props => (props.active ? 'scaleX(-1)' : 'scaleX(1)')};
  position: fixed;
  top: 6px;
  left: 11px;
  z-index: ${zIndex.openMenu};

  ${device.desktop} {
    display: none;
  }
`;
export const CompanyName = styled.div`
  margin-right: ${props => props.theme.global.gutterSpace * 2}px;
  color: ${props => props.theme.colors.grey900};
  font-size: ${props => props.theme.fontSizes[2]};

  ${device.mobile} {
    display: none;
  }
`;

export const StyledBox = styled(Box)`
  ${device.tablet} {
    display: none;
  }
`;

export const StyledButton = styled(Button)<ButtonProps>`
  ${device.desktop} {
    width: 175px;
  }
  ${device.mobile} {
    padding: 10px;
  }
  color: ${props => props.theme.colors.grey900};
`;

export const Strong = styled.strong`
  color: ${props => props.theme.colors.grey900};
  font-size: ${props => props.theme.fontSizes[3]};
  font-weight: 600;
`;

export const P = styled.p`
  color: ${props => props.theme.colors.grey900};
  font-size: ${props => props.theme.fontSizes[2]};
`;

const largura = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

const measureItWindowToReturnMargin = largura => {
  if (largura <= 1300) return 1;
  if (largura <= 1800) return 8;
  if (largura <= 1950) return 17;
  return 9;
};

export const spotlightStyles = {
  spotlight: {
    maxWidth: 94,
    minWidth: 94,
    maxHeight: 40,
    minHeight: 40,
    borderRadius: 12,
    marginTop: 10.5,
    marginLeft: measureItWindowToReturnMargin(largura),
  },
};
